<template>
    <div>
        <div class="row">
            <div class="col-lg-3">
                <div class="form-group">
                    <label for="state_id">Estado</label>
                    <select name="state_id"
                            id="state_id"
                            class="form-control inputPerfil"
                            v-model="selectedState">
                        <option :value="null" selected>Selecione</option>
                        <option v-for="state in states" :key="state.id" :value="state">
                            {{ state.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <button type="button" class="btn btn-primary" @click="filterTable">Filtrar</button>
            </div>
        </div>
        <div style="overflow-x:auto; margin-top: 20px">
            <table id="bids_table" class="table table-responsive table-hover table-mail minhasDemandasTable">
                <thead>
                <tr>
                    <th>Nome</th>
                    <th>Qtde. Peritos</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="field in fields"><td>{{ field.name }}</td><td><a target="_blank" :href="'/admin/reports/experts/fields/detail/'+field.id">{{ field.total }}</a></td></tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            fields:{
                type:Array,
            },
            states:{
                type:Array,
            }
        },
        data(){
            return {
                selectedState:null,
            }
        },
        mounted(){

        },
        methods: {
            filterTable(){
                if(this.selectedState)
                    location.href='/admin/reports/fields/states?state_id='+this.selectedState.id
            }
        }
    }
</script>